import {
  CommentEntry,
  NavigationEntry,
  RessortEntry,
  RessortModuleEntry,
  SearchResult,
  CmpMappingResponse,
  TeaserEntry,
  VoteEntry
} from "./interfaces";
import { getResponseEntry } from "./externalApi";
import { getPageInformation } from "./pageInformation";

async function load(url) {
  try {
    const res = await fetch(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  
    return res;
  } catch (error) {
    return {status: 500} as Response
  }  
}

async function post(url, data) {
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  
    return res;
  } catch (error) {
    return {status: 500} as Response
  }  
}

export async function loadNavigationClientSide(
  id: string | undefined
): Promise<NavigationEntry | null> {
  let url = "/api/navigation";
  if (id) {
    url += "/" + id;
  }
  const res = await load(url);
  try {
    if (res.status === 200) {
      const json = await res.json();
      return json as NavigationEntry;
    } else {
      return getResponseEntry(res) as NavigationEntry;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function loadPersonalRessortClientSide(id: string): Promise<RessortEntry | null> {
  let url = "/api/personalressort";
  if (id) {
    url += "/" + id;
  }
  const res = await load(url);
  try {
    if (res.status === 200) {
      const json = await res.json();
      return json as RessortEntry;
    } else {
      return getResponseEntry(res) as RessortEntry;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}
 
export async function loadModuleClientSide(
  ressortId: string | undefined,
  id: string,
  page: number,
  excludeIdList: string,
  searchParams?: any  
): Promise<RessortModuleEntry | null> {
  let url = "/api/module/" + id + "/" + page + "?excludeIdList=" + excludeIdList;
  if(ressortId && ressortId != "" && ressortId != "undefined") {
    url += "&ressortId=" + ressortId
  }
  if(searchParams) {
    Object.keys(searchParams).forEach(key => {
      url += `&${key}=${searchParams[key]}`
    })
  }
  const res = await load(url);
  try {
    if (res.status === 200) {
      const json = await res.json();
      return json as RessortModuleEntry;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}
 
export async function loadModuleByTeaserIdsClientSide(
  ids: string
): Promise<RessortModuleEntry | null> {
  let url = "/api/merkliste/" + ids;
  const res = await load(url);
  try {
    if (res.status === 200) {
      const json = await res.json();
      return json as RessortModuleEntry;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function loadCommentsClientSide(
  id: string,
  page: number
): Promise<CommentEntry[] | null> {
  let url = `/api/comments/${id}/${page}`;
  const res = await load(url);
  try {
    if (res.status === 200) {
      const json = await res.json();
      return json as CommentEntry[];
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const postCommentsClientSide = async (articleId: string, text: string, ssoJwtToken: string) => {
  let url = `/api/comment/${articleId}`
  const res = await post(url, { text: text, ssoJwtToken: ssoJwtToken})
  try {
    if (res.status === 200) {
      const json = await res.json();
      return json as any;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}


export async function loadCmpMappingClientSide(): Promise<CmpMappingResponse | null> {
  let url = '/api/cmpmapping'
  try {
    const res = await load(url)
    if(res.status === 200)
    {
      const json = await res.json();
      return json as CmpMappingResponse;
    }
    else
    {
      return null
    }
  } catch (error) {
    return null
  }
}

export async function voteClientSide(
  id: string,
  data: any
): Promise<VoteEntry[] | null> {
  let url = `/api/voting/${id}`
  try {
    const res = await post(url, data)
    if(res.status === 200 || res.status === 201)
    {
        const json = await res.json();
        return json as VoteEntry[]
    }
    else
    {
      return null
    }
  } catch (error) {
    return null
  }
}

export async function sendDoiMailsClientSide(
  id: string,
  isOptin: boolean,
  data: any
): Promise<{ status: number; json: any }> {
  let url = `/api/voting/send-doi-mails/${id}?isOptin=${isOptin}`
  try {
    const res = await post(url, data)
    let json: any = null
    try {
      json = await res.json()
    } catch (e) {
      json = null
    }
    return { status: res.status, json }
  } catch (error) {
    return { status: 500, json: null }
  }
}

export async function sendVoteDataClientSide(
  data: string
): Promise<{ status: number; json: any }> {
  let url = `/api/voting/data?data=${encodeURIComponent(data)}`
  try {
    const res = await post(url, {})
    let json: any = null
    try {
      json = await res.json()
    } catch (e) {
      json = null
    }
    return { status: res.status, json }
  } catch (error) {
    return { status: 500, json: null }
  }
}

export async function sendVoteOptInDataClientSide(
  data: string
): Promise<{ status: number; json: any }> {
  let url = `/api/voting/optinData?optinData=${encodeURIComponent(data)}`
  try {
    const res = await post(url, {})
    let json: any = null
    try {
      json = await res.json()
    } catch (e) {
      json = null
    }
    return { status: res.status, json }
  } catch (error) {
    return { status: 500, json: null }
  }
}

export async function searchClientSide(
  query: string,
  sort: string,
  page: number
): Promise<SearchResult | null> {
  let url = `/api/search/${query}/${sort}/${page}`;
  const res = await load(url);
  try {
    if (res.status === 200) {
      const json = await res.json();
      return {...json, pageInformation: getPageInformation(json)} as SearchResult;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function searchAutocompleteClientSide(
  query: string,
): Promise<TeaserEntry[]> {
  let url = `/api/search-autocomplete/${query}`;
  const res = await load(url);
  try {
    if (res.status === 200) {
      const json = await res.json();
      return json;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
    return [];
  }
}
